import { gql } from "@apollo/client";

export const MARKETPLACE_LISTING_FIELDS = `
  id
  type
  status
  title
  description
  price
  city
  state
  contactEmail
  contactPhone
  ownerUserId
  ownerBusinessId
  ownerBusinessName
  beds
  capacity
  occupancy
  giftCategory
  ageGroup
  giftImageUrl
  imageUrls
  imageUrl
  createdAt
  updatedAt
`;

export const GET_MARKETPLACE_LISTINGS = gql`
  query MarketplaceListings(
    $q: String
    $type: MarketplaceListingType
    $maxPrice: Float
    $status: MarketplaceListingStatus
    $limit: Int
    $offset: Int
  ) {
    marketplaceListings(
      q: $q
      type: $type
      maxPrice: $maxPrice
      status: $status
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        ${MARKETPLACE_LISTING_FIELDS}
      }
    }
  }
`;

export const GET_MY_MARKETPLACE_LISTINGS = gql`
  query MyMarketplaceListings($limit: Int, $offset: Int) {
    myMarketplaceListings(limit: $limit, offset: $offset) {
      total
      items {
        ${MARKETPLACE_LISTING_FIELDS}
      }
    }
  }
`;
